import { render, staticRenderFns } from "./beian.vue?vue&type=template&id=0cd56f07&scoped=true"
import script from "./beian.vue?vue&type=script&lang=js"
export * from "./beian.vue?vue&type=script&lang=js"
import style0 from "./beian.vue?vue&type=style&index=0&id=0cd56f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd56f07",
  null
  
)

export default component.exports